'use strict';

module.exports = function(newBlendingMode) {
	this.context.clearRect(0, 0, this.x1, this.y1);
	this.context.globalCompositeOperation =
		this.image.blendingMode = newBlendingMode;
	this.validateInput('blendingMode');
	if (this.isPaused) this.refreshColors();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/changeBlendingMode.js
// module id = abZQ
// module chunks = 0 1 2 6